import { Typography } from '@tempmee/react';
import { Box, Row } from '~/commonComponents';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

interface IJobStatusInfoProps {
  jobStatus: JobPostingStatus;
}

export const JobStatusInfo = ({ jobStatus }: IJobStatusInfoProps) => (
  <Row alignItems="center" gap={6}>
    <Typography as="span" bold size="body_large" style={{ textWrap: 'nowrap' }}>
      Job Status<Typography as="span">:</Typography>
    </Typography>
    <Box
      backgroundColor={JobPostingStatusMapper.getColor(jobStatus)}
      borderRadius="100%"
      height={10}
      width={10}
    />
    <Typography as="span">{JobPostingStatusMapper.toHumanReadable(jobStatus)}</Typography>
  </Row>
);
